import { render, staticRenderFns } from "./cg-event-bands-main.vue?vue&type=template&id=3848f6b0&scoped=true"
import script from "./cg-event-bands-main.vue?vue&type=script&lang=js"
export * from "./cg-event-bands-main.vue?vue&type=script&lang=js"
import style0 from "./cg-event-bands-main.vue?vue&type=style&index=0&id=3848f6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848f6b0",
  null
  
)

export default component.exports